import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { PricingDistributionDisplayComponent } from '@products/pricing-distribution/pricing-distribution-component.interface';
import { PricingDistributionConfig } from '@products/pricing-distribution/pricing-distribution.config';
import { PricingService } from '@products/pricing-distribution/services/pricing.service';
import {
  PricingRangeUpdateValues,
  PricingState,
  ProductDetailConfiguration,
} from '@types';
import { Logger } from '@utils/logger';
import { Subscription } from 'rxjs';
const logger = Logger.getLogger('PremiumDiscountAnalysisComponent');

@Component({
  selector: 'ft-premium-nav-viv-analysis',
  templateUrl: './premium-discount-nav-viv.component.html',
  styleUrls: ['./premium-discount-nav-viv.component.scss'],
})
export class PremiumDiscountNavVivComponent
  extends BaseProductDetailComponent
  implements PricingDistributionDisplayComponent, OnDestroy {
  dataSubscription: Subscription;
  pricingState: PricingState;

  constructor(
    private pricingService: PricingService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  populate(
    componentConfig: PricingDistributionConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ): void {
    this.initialize(brConfig, component, page);
    if (this.brConfig.fundId) {
      this.pricingService.setConfigurationName(
        componentConfig.configurationName
      );
      this.dataSubscription = this.pricingService.pricingState$.subscribe(
        (state) => {
          this.pricingState = state;
          this.cdr.detectChanges();
        }
      );
      this.pricingService.populate(brConfig);
    }
  }

  updatePremiumDiscountNavViivChart(
    pricingChartRangeUpdateValues: PricingRangeUpdateValues
  ): void {
    this.pricingService.createPremiumDiscountNavViivChart(
      pricingChartRangeUpdateValues.selectedToggleRange,
      pricingChartRangeUpdateValues.fromDate,
      pricingChartRangeUpdateValues.toDate
    );
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
  }
}
